import React, { useState, useEffect } from "react";
import { DateIRLToErache, AgeCalculator } from "../utils/dateConverters";
//import { getCurrentDate, getCurrentTime } from '../utils/dateUtils';
import styled from "styled-components";
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import "react-datepicker/dist/react-datepicker.css";
import "./Converter.css";
import { Container } from "./styles";

registerLocale("fr", fr);

const IRLtoEracheConverter = () => {
  const [date, setDate] = useState(getInitialDate()); // Initialise avec l'heure actuelle
  const [computedDate, setComputedDate] = useState("");
  const [computedAge, setComputedAge] = useState("");
  const [, setCopySuccess] = useState(false);
  const [buttonColor, setButtonColor] = useState("var(--accent)");
  const [buttonText, setButtonText] = useState("Copier");

  useEffect(() => {
    updateResult(date);
  }, [date]);

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    updateResult(selectedDate);
  };

  const updateResult = (selectedDate) => {
    const conversionResult = DateIRLToErache(selectedDate, true);
    const ageResult = AgeCalculator(selectedDate);
    setComputedDate(conversionResult);
    setComputedAge(ageResult);
  };

  function getInitialDate() {
    const currentTime = new Date();
    const roundedMinutes = Math.round(currentTime.getMinutes() / 20) * 20;
    const initialDate = new Date(
      currentTime.getFullYear(),
      currentTime.getMonth(),
      currentTime.getDate(),
      currentTime.getHours(),
      roundedMinutes
    );
    return initialDate;
  }

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(computedDate)
      .then(() => {
        setCopySuccess(true);
        setButtonText("Copié!");
        setButtonColor("var(--accent-hover)");
        // After some time, reset
        setTimeout(() => {
          setCopySuccess(false);
          setButtonColor("var(--accent)");
          setButtonText("Copier");
        }, 2000);
      })
      .catch((error) =>
        console.error("Erreur lors de la copie dans le presse-papiers :", error)
      );
  };

  return (
    <Container>
      <h1>Convertisseur de dates</h1>
      <ConverterContainer>
        <Label>Choisissez la date et l'heure à convertir:</Label>
        <DatePicker
          showIcon
          selected={date}
          showTimeSelect
          timeCaption="Heure"
          open={false}
          locale="fr"
          dateFormat="yyyy-MM-dd p"
          onChange={handleDateChange}
          showYearDropdown
          showMonthDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={30}
        />
        <DatePicker
          showIcon
          selected={date}
          showTimeSelect
          timeCaption="Heure"
          onChange={handleDateChange}
          locale="fr"
          dateFormat="yyyy-MM-dd p"
          timeFormat="HH:mm"
          timeIntervals={20}
          inline
          showYearDropdown
          showMonthDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={30}
        />

        <CalendarName>Calendrier erachien:</CalendarName>
        <Result>
          {computedDate}
          <CopyButton onClick={copyToClipboard} buttonColor={buttonColor}>
            {buttonText}
          </CopyButton>
        </Result>
        {computedAge}
      </ConverterContainer>
    </Container>
  );
};

const ConverterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ccc;
`;

const Label = styled.label`
  margin-bottom: 5px;
`;

const Result = styled.div`
  margin-top: 10px;
  font-weight: bold;
  font-size: 1.2em;
  display: flex;
  align-items: center;
  min-width: 40vw;
  justify-content: space-between;
  @media (max-width: 768px) {
    min-width: 60vw;
    flex-direction: column;
    align-items: center;
  }
`;

const CopyButton = styled.button`
  margin-left: 10px;
  margin-right: 0;
  padding: 5px 10px;
  background-color: ${(props) => props.buttonColor || "var(--accent)"};
  color: #13110e;
  border: 1px solid var(--accent);
  border-radius: var(--radius-md);
  min-width: 100px;
  cursor: pointer;
  &:hover {
    background-color: var(--accent-hover);
    border-color: var(--accent-hover);
    box-shadow: 0 0 0 3px var(--accent-bg);
  }
  @media (max-width: 768px) {
    margin-top: 10px;
    padding: 10px 20px;
    font-size: 1.2em;
    &:active {
      background-color: var(--accent-hover);
    }
    min-width: 30vw;
  }
`;

const CalendarName = styled.div`
  margin-top: 20px;
  font-size: 1.2em;
`;

export default IRLtoEracheConverter;
